import { ExpressCheckoutUI } from "./ExpressCheckoutUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { Variant } from "../../types/types";

export function ExpressCheckout({ product }: Pick<StandardProps, "product">) {
  const productId = product.aliases.pimProductId;
  const { variant } = useVariant(product);
  const skuId = getSkuId(variant);
  const { title, price } = variant;

  return (
    <ExpressCheckoutUI
      productId={productId}
      variantId={variant.id}
      title={encodeURI(title)}
      price={price?.value}
      skuId={skuId}
    />
  );
}

function getSkuId(variant: Variant) {
  if (
    variant.__typename === "StaticBundleVariant" ||
    variant.__typename === "RetiredStaticBundleVariant"
  ) {
    return variant.components[0]!.variant.aliases.skuId;
  }

  return variant.aliases.skuId;
}
